import { ActivityTagItem } from '@spotify/plugin-confidence-activity-react';
import { createMetricUpdatesChangeExtension } from '@spotify/plugin-confidence-metrics-react';

const formatPreferredDirection = (value: unknown): string => {
  if (value === 'INCREASE') return 'Increase';
  if (value === 'DECREASE') return 'Decrease';
  return 'None';
};

export const METRIC_PREFERRED_DIRECTION_CHANGE_EXTENSION =
  createMetricUpdatesChangeExtension({
    id: 'metric-preferred-direction-change',
    predicate: ({ change }) => change.fieldPath === '/preferred_direction',
    render: ({ change }) => (
      <ActivityTagItem
        oldValue={formatPreferredDirection(change.oldValue)}
        newValue={formatPreferredDirection(change.newValue)}
      />
    ),
  });
